import { DatePipe } from '@angular/common';
import {Component, ElementRef, forwardRef, HostListener, Input, OnInit, ViewChild} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as moment from 'moment';
import {CommonService, ReportService, ToasterService} from 'src/app/services';

@Component({
  selector: 'app-custom-datepicker',
  templateUrl: './custom-datepicker.component.html',
  styleUrls: ['./custom-datepicker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomDatepickerComponent),
      multi: true
    }
  ]
})
export class CustomDatepickerComponent implements OnInit, ControlValueAccessor {

  @ViewChild('datePicker') datePicker;
  @ViewChild('editor') editor: ElementRef;
  @Input() dateInFormat: string;
  @Input() dateOutFormat: string;
  @Input() twoMonthMode: boolean;
  @Input() minDateString: string;
  @Input() maxDateString: string;
  @Input() dateValue: string;
  @Input() placeholder: string;
  @Input() isDisable: boolean = false;
  @Input() isYearVisible: boolean = true;
  @Input() isInterimPopup: boolean = false;
  @Input() showOnlyCurrentYear: boolean = false;
  @Input() displayFormat: string = "MMMM dd, YYYY";
  dateFieldMask: Array<any> = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  editorFormat: string;
  minDate;
  maxDate;
  editorValue: string;

  outPickedUpdate = '';
  modelDate = '';
  editorActive: boolean = false;

  currentDate: Date;
  dateSecondCalendar: Date;
  Months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];
  lastDay;
  days: { day: number, dayClicked: boolean, active: string, selectable: boolean }[] = [];
  daysBefore: [] = [];
  daysAfter: [] = []
  firstDayIndex;
  lastDayIndex;
  lastDaySecondCalendar;
  daysSecondCalendar: { day: number, dayClicked: boolean, active: string, selectable: boolean }[] = [];
  daysBeforeSecondCalendar: [] = [];
  daysAfterSecondCalendar: [] = []
  firstDayIndexSecondCalendar;
  lastDayIndexSecondCalendar;
  showDate = false;

  todayDateForNote: string = '';
  showDateError: boolean = false;

  onChange = (_) => {
    // blank
  };
  onTouched = () => {
    // blank
  };

  constructor(
    public reportService: ReportService,
    public datePipe: DatePipe,
    private toastr: ToasterService,
    public common: CommonService
  ) { }

  writeValue(value: string): void {
    this.modelDate = "";
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  ngOnInit(): void {
    this.todayDateForNote = this.datePipe.transform(new Date(), 'MM/dd/yyyy');

    this.minDate = moment(this.minDateString, this.dateInFormat);
    this.maxDate = moment(this.maxDateString, this.dateInFormat);
    if (this.dateValue) {
      this.currentDate = new Date(this.dateValue + ' 00:00');
    } else {
      this.currentDate = new Date();
      this.currentDate.setDate(1);
    }

    this.lastDay = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0).getDate();
    this.firstDayIndex = this.currentDate.getDay();
    this.lastDayIndex = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0).getDay();
    this.days = []
    this.daysAfter = []
    this.daysBefore = []
    this.renderDate(this.currentDate, this.lastDay, this.firstDayIndex, this.lastDayIndex, this.days, this.daysAfter, this.daysBefore)

    if (this.twoMonthMode) {
      this.dateSecondCalendar = new Date();
      this.dateSecondCalendar.setDate(1);
      this.dateSecondCalendar.setMonth(this.currentDate.getMonth() + 1);
      this.dateSecondCalendar.setMonth(this.currentDate.getMonth() + 1);

      const secondYear = (this.currentDate.getMonth() + 1) == 12 ? this.currentDate.getFullYear() + 1 : this.currentDate.getFullYear();
      this.dateSecondCalendar.setFullYear(secondYear);

      this.lastDaySecondCalendar = new Date(this.dateSecondCalendar.getFullYear(), this.dateSecondCalendar.getMonth() + 1, 0).getDate();
      this.firstDayIndexSecondCalendar = this.dateSecondCalendar.getDay();
      this.lastDayIndexSecondCalendar = new Date(this.dateSecondCalendar.getFullYear(), this.dateSecondCalendar.getMonth() + 1, 0).getDay();
      this.daysSecondCalendar = []
      this.daysAfterSecondCalendar = []
      this.daysBeforeSecondCalendar = []
      this.renderDate(this.dateSecondCalendar, this.lastDaySecondCalendar, this.firstDayIndexSecondCalendar, this.lastDayIndexSecondCalendar, this.daysSecondCalendar, this.daysAfterSecondCalendar, this.daysBeforeSecondCalendar)
    }

    if (this.dateValue) {
      const receivedDate = new Date(this.dateValue + ' 00:00');
      this.onclickFirstCalendarDay(receivedDate.getDate() - 1);
    }

  }

  onClickDateIcon() {
    this.showDate = !this.showDate;
  }

  renderDate(date: Date, lastDay, firstDayIndex, lastDayIndex, days: any[], daysAfter: any[], daysBefore: any[]) {

    days.splice(0, days.length)
    daysAfter.splice(0, daysAfter.length)
    daysBefore.splice(0, daysBefore.length)

    for (let i = 1; i <= lastDay; i++) {
      days.push({ day: i, dayClicked: false, selectable: true })
    }

    for (let x = firstDayIndex; x > 0; x--) {
      daysBefore.push(x);
    }

    for (let y = lastDayIndex; y < 6; y++) {
      daysAfter.push(y);
    }

    for (let j = 0; j < days.length; j++) {
      let tempDate = moment(`${j + 1}/${date.getMonth() + 1}/${date.getFullYear()}`, "DD/MM/YYYY")
      if (!tempDate.isBetween(this.minDate, this.maxDate))
        days[j]['selectable'] = false;
    }
  }

  onClickLeft() {
    if (this.twoMonthMode) {
      this.currentDate.setDate(1);
      this.dateSecondCalendar.setDate(1);
      if(this.showOnlyCurrentYear && this.currentDate.getMonth() === 1){
        this.currentDate.setMonth(this.currentDate.getMonth() - 1);
        this.dateSecondCalendar.setMonth(this.dateSecondCalendar.getMonth() - 1);
      }else {
        this.currentDate.setMonth(this.currentDate.getMonth() - 2);
        this.dateSecondCalendar.setMonth(this.dateSecondCalendar.getMonth() - 2);
      }

      this.lastDaySecondCalendar = new Date(this.dateSecondCalendar.getFullYear(), this.dateSecondCalendar.getMonth() + 1, 0).getDate();
      this.firstDayIndexSecondCalendar = this.dateSecondCalendar.getDay();
      this.lastDayIndexSecondCalendar = new Date(this.dateSecondCalendar.getFullYear(), this.dateSecondCalendar.getMonth() + 1, 0).getDay();
      this.renderDate(this.dateSecondCalendar, this.lastDaySecondCalendar, this.firstDayIndexSecondCalendar, this.lastDayIndexSecondCalendar, this.daysSecondCalendar, this.daysAfterSecondCalendar, this.daysBeforeSecondCalendar)
    } else {
      this.currentDate.setDate(1);
      this.currentDate.setMonth(this.currentDate.getMonth() - 1)
    }

    this.lastDay = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0).getDate();
    this.firstDayIndex = this.currentDate.getDay();
    this.lastDayIndex = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0).getDay();

    this.renderDate(this.currentDate, this.lastDay, this.firstDayIndex, this.lastDayIndex, this.days, this.daysAfter, this.daysBefore)

  }

  onClickRight() {
    if (this.twoMonthMode) {
      this.currentDate.setDate(1);
      this.dateSecondCalendar.setDate(1);

      if(this.showOnlyCurrentYear && this.dateSecondCalendar.getMonth() === 10){
        this.currentDate.setMonth(this.currentDate.getMonth() + 1);
        this.dateSecondCalendar.setMonth(this.dateSecondCalendar.getMonth() + 1);
      }else{
        this.currentDate.setMonth(this.currentDate.getMonth() + 2);
        this.dateSecondCalendar.setMonth(this.dateSecondCalendar.getMonth() + 2);
      }

      this.lastDaySecondCalendar = new Date(this.dateSecondCalendar.getFullYear(), this.dateSecondCalendar.getMonth() + 1, 0).getDate();
      this.firstDayIndexSecondCalendar = this.dateSecondCalendar.getDay();
      this.lastDayIndexSecondCalendar = new Date(this.dateSecondCalendar.getFullYear(), this.dateSecondCalendar.getMonth() + 1, 0).getDay();
      this.renderDate(this.dateSecondCalendar, this.lastDaySecondCalendar, this.firstDayIndexSecondCalendar, this.lastDayIndexSecondCalendar, this.daysSecondCalendar, this.daysAfterSecondCalendar, this.daysBeforeSecondCalendar)

    } else {
      this.currentDate.setDate(1);
      this.currentDate.setMonth(this.currentDate.getMonth() + 1)
    }

    this.lastDay = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0).getDate();
    this.firstDayIndex = this.currentDate.getDay();
    this.lastDayIndex = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0).getDay();

    this.renderDate(this.currentDate, this.lastDay, this.firstDayIndex, this.lastDayIndex, this.days, this.daysAfter, this.daysBefore)
  }

  onclickFirstCalendarDay(i: number) {
    if (this.days[i].selectable === false)
      return

    for (let x = 0; x < this.lastDay; x++) {
      this.days[x]['active'] = '';
    }

    for (let x = 0; x < this.lastDaySecondCalendar; x++) {
      this.daysSecondCalendar[x]['active'] = '';
    }

    this.days[i]['active'] = 'active';

    let m = moment(`${this.currentDate.getMonth() + 1}/${i + 1}/${this.currentDate.getFullYear()}`)
    this.outPickedUpdate = m.format(this.dateOutFormat)
    this.onChange(m.format(this.dateInFormat))

    if (this.showDate)
      this.showDate = !this.showDate;
  }

  onclickSecondCalendarDay(i: number) {
    if (this.daysSecondCalendar[i].selectable === false)
      return

    for (let x = 0; x < this.lastDay; x++) {
      this.days[x]['active'] = '';
    }

    for (let x = 0; x < this.lastDaySecondCalendar; x++) {
      this.daysSecondCalendar[x]['active'] = '';
    }

    this.daysSecondCalendar[i]['active'] = 'active'
    let m = moment(`${this.dateSecondCalendar.getMonth() + 1}/${i + 1}/${this.dateSecondCalendar.getFullYear()}`);
    this.outPickedUpdate = m.format(this.dateOutFormat);
    this.onChange(m.format(this.dateInFormat));

    if (this.showDate)
      this.showDate = !this.showDate;
  }

  @HostListener('document:click', ['$event.target'])
  clickedOutside(targetElement){
    const clickedInside = this.datePicker.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.showDate = false;
    }
  }

  /** Activate editor  */
  editorEnabled(): void {
    if(this.displayFormat === "MMMM dd, yyyy"){
      this.editorFormat = "MM/DD/YYYY";
    } else{
      this.dateFieldMask = [/\d/, /\d/, '/', /\d/, /\d/];
      this.editorFormat = "MM/DD";
    }

    if(this.outPickedUpdate){
      this.editorValue = moment(this.outPickedUpdate).format(this.editorFormat);
    }

    setTimeout(()=>{
      this.editor.nativeElement.focus();
    }, 50);

    this.editorActive = true;
  }

  /** Editor deactivated */
  editorFinished(event: any, prevent: boolean = false): void {
    if(prevent)
      event.preventDefault();

    let newDate = moment(this.editorValue, this.editorFormat, true);
    if(newDate.isValid()){
      let enteredDate = moment(newDate).format(this.dateInFormat);

      const maxDateForCheck = moment(this.maxDate, this.dateInFormat).add(-1, 'days');
      const minDateForCheck = moment(this.minDate, this.dateInFormat).add(1, 'days');

      // Check min-max range
      if(!moment(enteredDate).isAfter(maxDateForCheck) && !moment(enteredDate).isBefore(minDateForCheck)){
        this.outPickedUpdate = enteredDate;
        this.onChange(this.outPickedUpdate);
        this.showDateError = false;
      } else {
        this.showDateError = true;
      }
    }else{
      if (this.isInterimPopup) {
        this.outPickedUpdate = null;
        this.showDateError = true;
        this.onChange(this.outPickedUpdate);
      } else {
        event.preventDefault();
      }
    }

    this.editorActive = false;
  }

  /** Show left icon */
  showPrevIcon(month: number, year: number): boolean{
    if(this.showOnlyCurrentYear){
      let cd = new Date();
      if(cd.getFullYear() === year && month > 0){
        return true;
      }else{
        return false;
      }
    }else{
      return true;
    }
  }

  /** Show right icon */
  showNextIcon(month: number, year: number): boolean{
    if(this.showOnlyCurrentYear){
      let cd = new Date();
      if(cd.getFullYear() === year && month < 11){
        return true;
      }else{
        return false;
      }
    }else{
      return true;
    }
  }
}
